export default __webpack_public_path__ + "static/import-f7bd83910d330a5c802bf481370a3a4f.png";